// ════════════════════════════════════════════════════════════════════════════
// UYGULAMA OLARAK KUR — kurulum daveti (partner panelindeki PwaInstallCard'ın eşi)
//
// Neden ürünün içinde: kurulu PWA ayrı pencerede durur, sekmeler arasında kaybolmaz
// ve bildirim/ses kısıtları gevşer — filo yöneticisi "atanmamış paket" uyarısını
// tarayıcı sekmesi kapalıyken de görebilir hâle gelir.
//
// Karar kalıcıdır: kurulduysa bir daha çıkmaz, "Daha sonra"da 7 gün susar.
// Bir kez göründüyse kullanıcı cevap verene kadar ekranda kalır (latch) — koşullar
// sonradan değişse de davet kaybolup kullanıcıyı şaşırtmaz.
// ════════════════════════════════════════════════════════════════════════════

import { useEffect, useRef, useState } from 'react';
import { createPortal } from 'react-dom';
import { Download, X, Monitor } from 'lucide-react';
import {
    canShowInstallCard,
    promptInstall,
    snoozeInstallCard,
    subscribeInstallState
} from '../../utils/pwaInstall';
import './PwaInstallCard.css';

const PwaInstallCard = () => {
    const [available, setAvailable] = useState(false);
    const [installed, setInstalled] = useState(false);
    const [allowed, setAllowed] = useState(false);
    const [latched, setLatched] = useState(false);
    const answered = useRef(false);

    useEffect(() => {
        setAllowed(canShowInstallCard());
        return subscribeInstallState((s) => {
            setAvailable(s.available);
            setInstalled(s.installed);
        });
    }, []);

    useEffect(() => {
        if (answered.current || latched) return;
        if (allowed && available && !installed) setLatched(true);
    }, [allowed, available, installed, latched]);

    if (!latched || installed || answered.current) return null;

    const later = () => {
        answered.current = true;
        setLatched(false);
        snoozeInstallCard();
    };

    const install = async () => {
        const res = await promptInstall();
        // Tarayıcı kutusunda "Kur"a basılmadıysa ısrar etme: 7 gün sonra tekrar sor.
        if (res !== 'accepted') snoozeInstallCard();
        answered.current = true;
        setLatched(false);
    };

    return createPortal(
        <div className="fpwa-card" role="dialog" aria-label="Uygulama olarak kur">
            <div className="fpwa-icon"><Monitor size={18} /></div>
            <div className="fpwa-body">
                <div className="fpwa-title">Filo panelini uygulama olarak kur</div>
                <div className="fpwa-text">
                    Ayrı pencerede açılır, sekmeler arasında kaybolmaz; bildirimleri kaçırmazsın.
                </div>
                <div className="fpwa-actions">
                    <button type="button" className="fpwa-btn primary" onClick={install}>
                        <Download size={14} /> Kur
                    </button>
                    <button type="button" className="fpwa-btn ghost" onClick={later}>
                        Daha sonra
                    </button>
                </div>
            </div>
            <button type="button" className="fpwa-close" onClick={later} aria-label="Kapat">
                <X size={16} />
            </button>
        </div>,
        document.body
    );
};

export default PwaInstallCard;
